import { useTranslation } from "react-i18next";
import { X } from "@phosphor-icons/react";
import { Button } from "@libs/zapi-ui/ds/components/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@libs/zapi-ui/ds/components/dialog";
import { FigmaTypography } from "@libs/zapi-ui/custom";

type TCancelAnalysisModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function CancelAnalysisModal({ isOpen, onClose, onConfirm }: TCancelAnalysisModalProps) {
  const { t } = useTranslation(["projectHome", "common"]);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        onClick={(e) => e.stopPropagation()}
        data-testid="cancel-analysis-modal"
        showCloseButton={false}
        closeLabel={t("common:close")}
        className="w-[440px] max-w-[440px] gap-4 rounded-xl border-0 ring-1 ring-inset p-5 sm:rounded-xl sm:max-w-[440px]"
      >
        <DialogHeader className="space-y-1 text-start">
          <DialogTitle render={<div className="flex h-8 items-center" />}>
            <FigmaTypography component="span" variant="heading-3" color="zinc900">
              {t("generation.cancelAnalysis")}
            </FigmaTypography>
          </DialogTitle>
          <FigmaTypography variant="body-2" color="zinc700">
            {t("generation.cancelAnalysisDescription")}
          </FigmaTypography>
        </DialogHeader>

        <div className="flex items-center justify-end gap-1">
          <Button
            variant="outline"
            type="button"
            className="shadow-none"
            onClick={onClose}
            data-testid="cancel-analysis-keep-generating-button"
          >
            {t("generation.keepGenerating")}
          </Button>
          <Button type="button" onClick={handleConfirm} data-testid="cancel-analysis-confirm-button">
            {t("generation.cancelAnalysis")}
          </Button>
        </div>

        <button
          type="button"
          aria-label={t("generation.close")}
          onClick={onClose}
          data-testid="cancel-analysis-close-button"
          className="absolute end-[14px] top-[14px] flex size-4 items-center justify-center text-innoveraZinc-900"
        >
          <X size={16} />
        </button>
      </DialogContent>
    </Dialog>
  );
}
